<template>
  <div>
    <h1>Thank you for your interest in our Vacation Rental. We will be following up with you shortly.</h1>
    <router-link to="/">
        <b-button class="submit" variant="primary" type="submit">Back to Home</b-button>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "SubmissionSuccess"
  }
</script>

<style lang="scss">
  .submit {
  margin-top: 40px;
}
</style>